
import { Component, Vue } from "vue-property-decorator";
import VerticalVideoep from "@/template/video/VerticalVideo.vue";
@Component
export default class VerticalVideo extends VerticalVideoep {}
